<div class="container">
  <div *ngIf="scapist | async as loadedScapist">
    <app-scapist-page [scapist]="loadedScapist"></app-scapist-page>
  </div>
</div>
